import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';

import { getCronTriggerPath } from '~entities/stripe/lib/cron-api-path';
import { baseAPI } from '~shared/api/base-api';

interface TriggerMembershipFeeReminderParams {
  isV2: boolean;
}

export const triggerMembershipFeeReminder = async (
  params: TriggerMembershipFeeReminderParams,
) => {
  const response = await baseAPI.post<{ ok?: true }>(
    getCronTriggerPath('membership-fee-reminder', params.isV2),
  );
  return response.data;
};

export const useTriggerMembershipFeeReminder = () => {
  return useMutation({
    mutationFn: triggerMembershipFeeReminder,
    onSuccess: () => {
      toast.success('Membership fee reminder cron triggered successfully');
    },
    onError: (error: unknown) => {
      const errorMessage =
        error &&
        typeof error === 'object' &&
        'response' in error &&
        error.response &&
        typeof error.response === 'object' &&
        'data' in error.response &&
        error.response.data &&
        typeof error.response.data === 'object' &&
        'message' in error.response.data &&
        typeof error.response.data.message === 'string'
          ? error.response.data.message
          : 'Failed to trigger membership fee reminder cron.';

      toast.error(errorMessage);
    },
  });
};
